/**
 * PLAYER interfaces and types
 */

import { IFootballTeam } from '../components/organisms/football-team/football-team';

export interface IReferee {
  fullname?: string | null;
  id: string | number | null; // BE sends STRING now
  name?: string | null;
  surname?: string | null;
  topPlayer?: boolean; // BE sends TOPPLAYER for REFEREES, too
  vote?: string;
}

export interface IPlayer extends IReferee {
  formationPlace?: formationPlaceType | formationPlaceRange; // FIXME: it's TEMPORARY, must choose what to do!
  jerseyNum?: number | null;
  photoUrl?: string | null; // ISS-6062 - Player picture for PREDICTED LINEUPS
  role: Role | null;
  startingLineup?: boolean;
}

// ISS-4975
export const formationPlaceArray = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
type formationPlaceRange = (typeof formationPlaceArray)[number] | null;
export interface IPlayerBE extends Omit<IPlayer, 'role' | 'formationPlace'> {
  formationPlace: formationPlaceRange;
}

/** ROLE */
export type Role = 'Manager' | 'Goalkeeper' | 'Defender' | 'Midfielder' | 'Forward';

export const roleList: Role[] = ['Goalkeeper', 'Defender', 'Midfielder', 'Forward', 'Manager'];

export const ROLE_COACH: Role = 'Manager';
export const ROLE_KEEPER: Role = 'Goalkeeper';
export const ROLE_FULLBACK: Role = 'Defender';
export const ROLE_MIDFIELD: Role = 'Midfielder';
export const ROLE_STRIKER: Role = 'Forward';

/**
 * FORMATION PLACES
 */

/** KEEPER  */
export const KEEPER: formationPlaceKeeper = 'KEEPER';
export type formationPlaceKeeper = 'KEEPER';

/** BACK */
export const CENTRE_BACK: formationPlaceBack = 'CENTRE_BACK';
export const CENTRE_BACK_RIGHT: formationPlaceBack = 'CENTRE_BACK_RIGHT';
export const CENTRE_BACK_LEFT: formationPlaceBack = 'CENTRE_BACK_LEFT';
export const FULL_BACK_RIGHT: formationPlaceBack = 'FULL_BACK_RIGHT';
export const FULL_BACK_LEFT: formationPlaceBack = 'FULL_BACK_LEFT';
export const SWEEPER: formationPlaceBack = 'SWEEPER';
export const WING_BACK_RIGHT: formationPlaceBack = 'WING_BACK_RIGHT';
export const WING_BACK_LEFT: formationPlaceBack = 'WING_BACK_LEFT';

export type formationPlaceBack =
  | 'CENTRE_BACK'
  | 'CENTRE_BACK_RIGHT'
  | 'CENTRE_BACK_LEFT'
  | 'FULL_BACK_RIGHT'
  | 'FULL_BACK_LEFT'
  | 'SWEEPER'
  | 'WING_BACK_RIGHT'
  | 'WING_BACK_LEFT';

/** MIDFIELD */
export const CENTRE_MIDFIELD: formationPlaceMidfield = 'CENTRE_MIDFIELD';
export const CENTRE_MIDFIELD_RIGHT: formationPlaceMidfield = 'CENTRE_MIDFIELD_RIGHT';
export const CENTRE_MIDFIELD_LEFT: formationPlaceMidfield = 'CENTRE_MIDFIELD_LEFT';
export const SIDE_MIDFIELD_RIGHT: formationPlaceMidfield = 'SIDE_MIDFIELD_RIGHT';
export const SIDE_MIDFIELD_LEFT: formationPlaceMidfield = 'SIDE_MIDFIELD_LEFT';
export const OFFENSIVE_MIDFIELD_RIGHT: formationPlaceMidfield = 'OFFENSIVE_MIDFIELD_RIGHT';
export const OFFENSIVE_MIDFIELD_LEFT: formationPlaceMidfield = 'OFFENSIVE_MIDFIELD_LEFT';
export const OFFENSIVE_MIDFIELD: formationPlaceMidfield = 'OFFENSIVE_MIDFIELD';
export const DEFENSIVE_MIDFIELD_RIGHT: formationPlaceMidfield = 'DEFENSIVE_MIDFIELD_RIGHT';
export const DEFENSIVE_MIDFIELD_LEFT: formationPlaceMidfield = 'DEFENSIVE_MIDFIELD_LEFT';
export const DEFENSIVE_MIDFIELD: formationPlaceMidfield = 'DEFENSIVE_MIDFIELD';

export type formationPlaceMidfield =
  | 'CENTRE_MIDFIELD'
  | 'CENTRE_MIDFIELD_RIGHT'
  | 'CENTRE_MIDFIELD_LEFT'
  | 'SIDE_MIDFIELD_RIGHT'
  | 'SIDE_MIDFIELD_LEFT'
  | 'OFFENSIVE_MIDFIELD_RIGHT'
  | 'OFFENSIVE_MIDFIELD_LEFT'
  | 'OFFENSIVE_MIDFIELD'
  | 'DEFENSIVE_MIDFIELD_RIGHT'
  | 'DEFENSIVE_MIDFIELD_LEFT'
  | 'DEFENSIVE_MIDFIELD';

/** FORWARD */
export const CENTRE_FORWARD_RIGHT: formationPlaceForward = 'CENTRE_FORWARD_RIGHT';
export const CENTRE_FORWARD_LEFT: formationPlaceForward = 'CENTRE_FORWARD_LEFT';
export const CENTRE_FORWARD: formationPlaceForward = 'CENTRE_FORWARD';
export const WINGER_RIGHT: formationPlaceForward = 'WINGER_RIGHT';
export const WINGER_LEFT: formationPlaceForward = 'WINGER_LEFT';
export const SECOND_STRIKER: formationPlaceForward = 'SECOND_STRIKER';
export const STRIKER_LEFT: formationPlaceForward = 'STRIKER_LEFT';
export const STRIKER_RIGHT: formationPlaceForward = 'STRIKER_RIGHT';
export const STRIKER: formationPlaceForward = 'STRIKER';

export type formationPlaceForward =
  | 'CENTRE_FORWARD_RIGHT'
  | 'CENTRE_FORWARD_LEFT'
  | 'CENTRE_FORWARD'
  | 'WINGER_RIGHT'
  | 'WINGER_LEFT'
  | 'SECOND_STRIKER'
  | 'STRIKER_LEFT'
  | 'STRIKER_RIGHT'
  | 'STRIKER';

export type formationPlaceType =
  | formationPlaceKeeper
  | formationPlaceBack
  | formationPlaceMidfield
  | formationPlaceForward;

export const formationPlaceList: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_RIGHT,
  FULL_BACK_LEFT,
  SWEEPER,
  WING_BACK_RIGHT,
  WING_BACK_LEFT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
  CENTRE_FORWARD,
  WINGER_RIGHT,
  WINGER_LEFT,
  SECOND_STRIKER,
  STRIKER_LEFT,
  STRIKER_RIGHT,
  STRIKER,
];

export enum playerCardtypes {
  PROBABILI_FORMAZIONI = 'probabili-formazioni',
  PAGELLE = 'pagelle',
  MARCATORI = 'classifica-marcatori',
}

export interface IPlayersPage {
  teams: IFootballTeam[];
  isEditor?: boolean;
  title: string;
  footerButtonLabel?: string;
  type: playerCardtypes;
}
